export const selectFactoryBranches = (state) => state.factoryBranches.branches;
export const selectFactoryBranchesLoading = (state) => state.factoryBranches.loading;
export const selectFactoryBranchesError = (state) => state.factoryBranches.error;